import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { MemberService } from './../../../../../rest/api/member.service';
import { AuthService } from './../../../../../services/auth.service';
import { HelperService } from './../../../../../services/helper.service';

import _ from 'lodash';

@Component({
  selector: 'app-edit-twodimension-sidebar',
  templateUrl: './edit-twodimension-sidebar.component.html',
  styleUrls: ['./edit-twodimension-sidebar.component.scss']
})
export class EditTwodimensionSidebarComponent implements OnInit, OnChanges {
  @Input() toggle;
  @Input() sidebarType;
  @Input() mediaData;
  @Input() hotspotListData;
  @Input() infohotspotListData;
  @Input() snapshotListData;
  @Input() spaceData;
  @Input() selectedMedia;
  @Output() changeMediaEmit = new EventEmitter();
  @Output() toggleMenuEmit = new EventEmitter();
  @Output() changeSpaceConfigEmit = new EventEmitter();
  @Output() emptyMediaEmit = new EventEmitter();
  @Output() deleteSnapshotEmit = new EventEmitter();
  @Output() showHideInfoEmit = new EventEmitter();
  @Output() deleteMediaEmit = new EventEmitter();
  @Output() openHighLightReelModalEmit = new EventEmitter();

  show: boolean;
  // show1: boolean;
  text: string;
  accessToken: any;

  spaceConfig = {
    show_drag: 1,
    auto_rotate: 1,
    show_control_buttons: 1,
    show_tour_button: 1
  };

  constructor(
    public memberService: MemberService,
    public authService: AuthService,
    public helperService: HelperService,
  ) {
    this.show = true;
    this.text = 'close';
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.spaceData && changes.spaceData.currentValue) {
      this.spaceConfig.show_drag = changes.spaceData.currentValue.config && changes.spaceData.currentValue.config.show_drag ?
      changes.spaceData.currentValue.config.show_drag : false;
      this.spaceConfig.auto_rotate = changes.spaceData.currentValue.config && changes.spaceData.currentValue.config.auto_rotate ?
      changes.spaceData.currentValue.config.auto_rotate : false;
      this.spaceConfig.show_control_buttons = changes.spaceData.currentValue.config &&
      changes.spaceData.currentValue.config.show_control_buttons ? changes.spaceData.currentValue.config.show_control_buttons : false;
      this.spaceConfig.show_tour_button = changes.spaceData.currentValue.config && changes.spaceData.currentValue.config.show_tour_button ?
      changes.spaceData.currentValue.config.show_tour_button : false;
    }
  }

  updateSpaceConfig(configData, type) {
    if (type === 'config') {
      this.spaceConfig.show_drag = configData.show_drag ? configData.show_drag : false;
      this.spaceConfig.auto_rotate = configData.auto_rotate  ? configData.auto_rotate : false;
      this.spaceConfig.show_control_buttons = configData.show_control_buttons  ? configData.show_control_buttons : false;
      this.spaceConfig.show_tour_button = configData.show_tour_button  ? configData.show_tour_button : false;
    } else {
      this.spaceConfig.show_drag = configData.config.show_drag ? configData.config.show_drag : false;
      this.spaceConfig.auto_rotate = configData.config.auto_rotate  ? configData.config.auto_rotate : false;
      this.spaceConfig.show_control_buttons = configData.config.show_control_buttons  ? configData.config.show_control_buttons : false;
      this.spaceConfig.show_tour_button = configData.config.show_tour_button  ? configData.config.show_tour_button : false;
    }
  }

  toggleMenu(sidebarType) {
    // check if current sidebar is opened if opened hide sidebar toggle
    let toggle;
    if (this.sidebarType === sidebarType) {
      toggle = !this.toggle;
    } else if (!this.toggle) {
      toggle = true;
    } else if (this.toggle) {
      toggle = true;
    } else {
      toggle = false;
    }
    this.sidebarType = sidebarType;
    this.toggleMenuEmit.emit({toggle, sidebarType: this.sidebarType});
  }

  changeMedia(media) {
    this.selectedMedia = media;
    this.changeMediaEmit.emit(media);
  }

  changeHotspot(hotspot) {
    if (hotspot && hotspot.media_id) {
      const selectedMedia = _.find(this.mediaData, {uuid: hotspot.media_id});
      if (selectedMedia) {
        this.selectedMedia = selectedMedia;
        this.changeMediaEmit.emit({changeHotspot: true, cameraPosition: hotspot.coordinates, selectedMedia });
      }
    }
  }


  toggleShowClass() {
    this.show = !this.show;
  }


  changeSpaceConfig(response) {
    // let formData;
    // formData = this.spaceConfig;
    // formData = this.helperService.updateJsonFormat(formData);
    // this.memberService.updateSpaceConfig(this.accessToken, this.spaceData.config.uuid, formData).subscribe(response => {
    //   this.updateSpaceConfig(response.data , 'config');
    this.changeSpaceConfigEmit.emit(response);
    // }, err => {
    //   this.updateSpaceConfig(this.spaceData, 'space');
    // });
  }

  modalCloseEmit(hotspot) {
    if ($('#editMediaTitleModal')) {
      $('#editMediaTitleModal').modal('hide');
    }
    // if (hotspot) {
    //   this.deleteHotspotEmit.emit(hotspot);
    // }
  }

  closeMenuEmit() {
    this.toggleMenuEmit.emit({toggle: false , sidebarType: undefined});
  }

  deleteSnapshot(response) {
    this.deleteSnapshotEmit.emit(response);
  }

  showHideInfo(response) {
    this.showHideInfoEmit.emit(response);
  }

  deleteMedia(response) {
    this.mediaData = _.filter(this.mediaData, (media) => {
      return media.uuid !== response.uuid;
    });
    this.deleteMediaEmit.emit(response);
  }

  openHighLightReelModal() {
    this.openHighLightReelModalEmit.emit(true);
  }

}
